export default __webpack_public_path__ + "static/assets/b30f04c76371555ea336da96ff4148f8.png";